module.exports = __webpack_public_path__ + "img/m_x.28d895ad.jpg";